export function repeat<T>(value: T, times: number): T[]
{
	return Array.from({ length: times }, () => value)
}
export function last<T>(arr: T[]): T | undefined
{
	return arr[arr.length - 1]
}

export function shuffle<T>(arr: T[]): T[]
{
	const result = [...arr]
	for (let i = result.length - 1; i > 0; i--)
	{
		const j = Math.floor(Math.random() * (i + 1))
		;[result[i], result[j]] = [result[j]!, result[i]!]
	}
	return result
}
